const validationsRules = {
  SIZE: 'size:500',
  FILE_LIMIT: 'maxFiles:5',
  ALPHA: 'alpha',
  ALPHA_SPACES: 'alpha_spaces',
  TEXTAREA_RANGE: 'between:15,1000',
  REQUIRED: 'required',
  FILE_TYPES: 'jpeg/JPEG/png/PNG/jpg/JPG',
  EMAIL: 'email',
}

export default validationsRules
